import { render, staticRenderFns } from "./FormAdd.vue?vue&type=template&id=18ba5713"
import script from "./FormAdd.vue?vue&type=script&lang=js"
export * from "./FormAdd.vue?vue&type=script&lang=js"
import style0 from "./FormAdd.vue?vue&type=style&index=0&id=18ba5713&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports